import Management from "./management/facial_management.store";
import User from "./user/facial_user.store";

export default {
  modules: {
    Management,
    User,
  },
};
